export class UserVideoModel {
  public id: number;
  public login: string;
  public lastName: string;
  public firstName: string;
  public profile: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: UserVideoModel[] = [];
    if (jsons) {
      jsons.forEach(json => {
        refs.push(new UserVideoModel().fromJSON(json));
      });
    }
    return refs;
  }
}
